import { DessertOption } from './types';

export const DESSERT_OPTIONS: DessertOption[] = [
  { id: "chocoladeMousse", name: "Chocolade mousse", price: 4.00 },
  { id: "tiramisuClassic", name: "Tiramisu classic", price: 4.00 },
  { id: "tiramisuSpeculoos", name: "Tiramisu speculoos", price: 4.00 },
  { id: "chocoladeBrownie", name: "Chocolade Brownie", price: 4.00 },
  { id: "lemonCheeseCake", name: "Lemon Cheese Cake", price: 4.00 },
];

export const INITIAL_FORM_DATA = {
  // Filled with the highlighted formula once the formulas are loaded
  formula: "",
  volwassenen: 0,
  kinderen: 0,
  vegetarisch: 0,
  keuze: "foodburgers",
  datum: "",
  startTijd: "",
  eindTijd: "",
  andereFoodtrucks: null as boolean | null,
  eventLocatieNaam: "",
  eventNaam: "",
  eventVoornaam: "",
  eventStraat: "",
  eventHuisnummer: "",
  eventPostcode: "",
  eventGemeente: "",
  eventEmail: "",
  eventPhoneNumber: "",
  factuurStraat: "",
  factuurHuisnummer: "",
  factuurPostcode: "",
  factuurGemeente: "",
  btwnummer: "",
  bedrijfsnaam: "",
  selectedBurgers: [],
  desserts: {
    chocoladeMousse: 0,
    tiramisuClassic: 0,
    tiramisuSpeculoos: 0,
    chocoladeBrownie: 0,
    lemonCheeseCake: 0,
  },
  opmerkingen: "",
  sameAsEvent: false,
};
